export const formatError = (error: any) => {
  const statusCode = error?.response?.status.toString();
  const detail = error?.response?.data?.errors?.[0]?.message;
  const message = error?.response
    ? `${statusCode}: ${detail}`
    : 'Data fetch failed. You may need to login again';

  return { statusCode: statusCode || '500', message };
};
